import React from 'react';
import ReactDOM from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import App from './App';
import './assets/css/bootstrap.min.css';
import './assets/css/bootstrap-print.css';
import './assets/css/base.css';
import './assets/css/rcstyle.scss';
import './assets/css/style1page.css';
import './assets/css/blockSNSEdit.css';
import './assets/css/animation.css';
import { UserProvider } from './contexts/UserContext';
import HTMLExportContextProvider from './contexts/HtmlExportContext';

import ImagesProvider from './contexts/ImagesContext';
import PagesProvider from './contexts/PagesContext';
import { TemplatesProvider } from './contexts/TemplatesContext';
import { LayoutProvider } from './contexts/LayoutContext';
import URLProvider from './contexts/URLContext';
import CategoriesProvider from './contexts/CategoriesContext';
import FilesProvider from './contexts/FileContext';
import VideosProvider from './contexts/VideoContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

const emotionCache = createCache({
  key: 'css',
  container: document.head,
  prepend: true,
  speedy: false,
});

root.render(
  <React.StrictMode>
    <CacheProvider value={emotionCache}>
      <HTMLExportContextProvider>
        <URLProvider>
          <LayoutProvider>
            <PagesProvider>
              <FilesProvider>
                <VideosProvider>
                  <CategoriesProvider>
                    <TemplatesProvider>
                      <ImagesProvider>
                        <UserProvider>
                          <HelmetProvider>
                            <Helmet titleTemplate="%s | BUILD-SELF" defaultTitle="BUILD-SELF" />
                            <App />
                          </HelmetProvider>
                        </UserProvider>
                      </ImagesProvider>
                    </TemplatesProvider>
                  </CategoriesProvider>
                </VideosProvider>
              </FilesProvider>
            </PagesProvider>
          </LayoutProvider>
        </URLProvider>
      </HTMLExportContextProvider>
    </CacheProvider>
  </React.StrictMode>,
);
